import React from 'react';
import { Layout } from 'fronton-react';
import { Section, SectionTitle, Typography } from 'common/components';
import { KitchenDesignPanel } from '../../../old-kitchen/components';
import {
  newKitchenHeaderSection,
  newKitchenHeaderSectionC,
  newKitchenHeaderText,
  newKitchenHeaderTitle,
} from './variant-a-styles';
import { NewKitchenHeaderCard } from '../new-kitchen-header-card';

type NewKitchenHeaderAProps = {
  experimentCookie: string;
  isConsultationFormVisible: boolean;
  signUpHref: string;
}

const TEXT_A = 'Сделаем дизайн-проект, поможем подобрать товары, привезём и\u00A0установим кухню';
const TEXT_B = 'Сделаем бесплатный дизайн-проект, поможем подобрать товары, привезём и\u00A0установим кухню';

export const NewKitchenHeaderA: React.FC<NewKitchenHeaderAProps> = ({ experimentCookie, isConsultationFormVisible, signUpHref }) => (
  <>
    <Layout>
      <Section className={experimentCookie === 'C' ? newKitchenHeaderSectionC : newKitchenHeaderSection}>
        <SectionTitle className={newKitchenHeaderTitle} as="h1">
          Кухни под ваши размеры быстро и&nbsp;выгодно
        </SectionTitle>
        <Typography className={newKitchenHeaderText} variant="l" size="body_long">
          {experimentCookie === 'A' ? TEXT_A : TEXT_B}
        </Typography>

        <NewKitchenHeaderCard experimentCookie={experimentCookie} signUpHref={signUpHref} />
      </Section>
    </Layout>

    <KitchenDesignPanel
      experimentCookie={experimentCookie}
      isConsultationFormVisible={isConsultationFormVisible}
      signUpHref={signUpHref}
      withWhiteBackground
    />
  </>
);
